/**
 * Les métadonnées d'un envoi à la télémétrie, nettoyées : sans `undefined`, sans clé qui porterait le
 * nom d'une personne. Pur, sans Bugsnag ni Expo : un moteur qui ne fait que les préparer (la voix,
 * dont le branchement est posé par l'écran) le lit sans charger le client natif.
 */
import { type TelemetryMetadata, type TelemetryValue } from "./telemetryClient"

/** Ce qu'une transition, une erreur ou une coupure porte en plus : des valeurs simples. */
export type TelemetryData = Record<string, TelemetryValue | undefined>

/** Une clé de métadonnée qui porterait le nom d'une personne : retirée avant l'envoi. */
const PERSONAL_KEY = /(^|_)(name|firstname|lastname|first_name|last_name|fullname|email|phone)$/i

/** Les métadonnées envoyées : sans `undefined`, sans clé qui porterait un nom. */
export function cleanMetadata(data: TelemetryData | undefined): TelemetryMetadata {
    const clean: TelemetryMetadata = {}
    if (data == null) return clean
    for (const [key, value] of Object.entries(data)) {
        if (value === undefined || PERSONAL_KEY.test(key)) continue
        clean[key] = value
    }
    return clean
}

/** Les dernières transitions qu'une erreur emporte : assez pour lire ce qui l'a précédée. */
export const TRANSITION_TRAIL_SIZE = 20

/** Le fil des dernières transitions d'une machine, qu'une erreur emporte : ce qui s'est passé juste avant. */
export class TransitionTrail {
    private readonly entries: string[] = []
    push(entry: string): void {
        this.entries.push(entry)
        if (this.entries.length > TRANSITION_TRAIL_SIZE) this.entries.shift()
    }
    list(): string[] {
        return [...this.entries]
    }
}
